import { IInstitution } from '@comptia-sso/core';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

// Styles.
import styles from './InstitutionItem.module.scss';

interface IInstitutionItemProps {
  institution: IInstitution;
}

export const InstitutionItem = (props: IInstitutionItemProps): ReactElement => {
  const { institution } = props;

  return (
    <Link
      className={styles.container}
      to={`/consent-approvers/institutions/${institution?.id}`}
    >
      <div className={styles.item}>
        <strong>Name</strong>
        <span>{institution.name}</span>
      </div>
      <div className={styles.item}>
        <strong>Status</strong>
        <span>{institution.isActive ? 'Active' : 'Inactive'}</span>
      </div>
      <div className={styles.link}>
        <ArrowForwardIos />
      </div>
    </Link>
  );
};
